import { useSelector } from 'react-redux';
import type { Params } from 'react-router';
import { useParams } from 'react-router';
import { selectConnectedCrmOrgs } from '../components/pages/environments/environmentsReducer';
import { extractShortUUID } from './readableUUID';

export const useSweepParams = <
  ParamsOrKey extends string | Record<string, string | undefined> = string,
>(): Readonly<
  [ParamsOrKey] extends [string]
    ? Params<ParamsOrKey>
    : Partial<ParamsOrKey> & {
        fullCrmOrgId?: string;
      }
> => {
  const params = useParams<ParamsOrKey>();
  const paramCrmOrgId = (params as any).crmOrgId;
  const crmOrgs = useSelector(selectConnectedCrmOrgs);
  if (paramCrmOrgId && paramCrmOrgId.length !== 36) {
    const shortCrmOrgId = extractShortUUID(paramCrmOrgId);
    if (shortCrmOrgId) {
      const crmOrg = crmOrgs.find((crmOrg) => crmOrg.id.startsWith(shortCrmOrgId));
      return {
        ...params,
        fullCrmOrgId: crmOrg?.id,
      };
    }
  }
  if (paramCrmOrgId && paramCrmOrgId.length === 36) {
    const crmOrg = crmOrgs.find((crmOrg) => crmOrg.id === paramCrmOrgId);
    return {
      ...params,
      fullCrmOrgId: crmOrg?.id,
    };
  }
  return params;
};
